export default {
  slices: [    
    {
      field: 'market',
      display: 'Market',
      map: {
        'general': {
          display: 'General Market',
          sortOrder: 1
        },
        'hispanic': {
          display: 'Hispanic Market',
          sortOrder: 2
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        tv: {
          display: 'Video',
          mediaType: 'mp4',
          sortOrder: 1
        }
      }
    },
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/metadata.js